import { Sector } from '@/domain/impact/impact.entity.ts';

export const questionsBySectorEss: Record<Sector, Array<string>> = {
  '': [],
  ANY: [],
  TEAM: [
    'ESS_7',
    'ESS_9',
    'QP_ESS_0_03',
    'ESS_10',
    'QP_ESS_0_04',
    'ESS_11',
    'ESS_12',
    'QP_ESS_0_1',
    'ESS_13',
    'QP_ESS_1',
    'ESS_14',
    'ESS_15',
    'ESS_17',
    'ESS_16',
    'ESS_16_1',
    'ESS_16_2',
    'ESS_18',
    'ESS_19',
    'ESS_20',
    'QP_ESS_5',
    'ESS_22',
    'ESS_23',
    'ESS_24',
    'ESS_27',
    'ESS_58',
    'ESS_59',
    'ESS_60',
    'ESS_25',
    'ESS_26',
    'QP_ESS_2',
    'ESS_38',
    'ESS_39',
    'ESS_40',
    'ESS_41',
    'ESS_42',
    'ESS_44',
    'ESS_50',
    'ESS_51',
  ],
  ARTISTS: [
    'ESS_1',
    'ESS_2',
    'ESS_3',
    'QP_ESS_0_01',
    'QP_ESS_0_02',
    'ESS_5',
    'QP_ESS_4',
    'ESS_53',
  ],
  PUBLIC: [
    'ESS_28',
    'ESS_29',
    'ESS_28_1',
    'ESS_30',
    'ESS_31',
    'ESS_32',
    'ESS_33',
    'ESS_35',
    'ESS_35_1',
    'ESS_36',
    'ESS_61',
    'ESS_62',
    'ESS_63',
    'ESS_46',
    'ESS_47',
    'QP_ESS_3',
    'ESS_48_5',
    'ESS_49',
  ],
  SITE: ['ESS_52'],
};
